import { LogOutIcon } from "lucide-react";
import { Link, useLocation } from "react-router";
import { Button } from "@/components/ui/button";
import { useT } from "@/i18n";

export type LogoutButtonProps = {
  className?: string;
};

/** Opens the sign-out confirmation (`LogoutDialog`) through `?logout`. */
export function LogoutButton({ className }: LogoutButtonProps) {
  const location = useLocation();
  const { t } = useT();

  return (
    <Button asChild variant="destructive" size="lg" className={className}>
      <Link to={`${location.pathname}?logout`}>
        <LogOutIcon data-icon="inline-start" className="rtl:rotate-180" />
        {t("signOut.title")}
      </Link>
    </Button>
  );
}
